import React from 'react'
import { BsShieldFillCheck } from 'react-icons/bs'
import { RiHeart2Fill } from 'react-icons/ri'
import {BiSearchAlt} from 'react-icons/bi';

const ServiceCard = ({ color, title, icon, subtitle }) => {
    return (
        <div className="flex flex-row justify-start items-center white-glassmorphism p-3 m-2 cursor-pointer hover:shadow-xl">
            <div className={`w-10 h-10 rounded-full flex justify-center items-center ${color} `}>
                {icon}
            </div>
            <div className="ml-5 flex-col flex-1">
                <h3 className='mt-2 text-white text-lg'>{title}</h3>
                <p className='mt-2 text-sm md:w-9/12 text-white text-lg'>{subtitle}</p>
            </div>
        </div>
    )
}

const Services = () => {
    return (
        <div className='flex w-full flex-col md:flex-row px-8 sm:px-2 justify-center items-center gradient-bg-welcome'>
            <div className="flex md:flex-row flex-col items-center justify-between mf:p-0 py-12 px-4">
                <div className="flex-1 flex flex-col justify-start items-start">
                    <h1 className='text-3xl sm:text-5xl py-2 text-gradient'>Services that we <br />continue to improve</h1>
                </div>
            </div>
            <div className="flex-1 flex flex-col justify-start items-center">
                <ServiceCard color='bg-[#2952e3]' title='Security Guaranteed' icon={<BsShieldFillCheck fontSize={21} className='text-white' />} subtitle='Security is guaranteed. We always maintain privacy and the quality of our products!' />
                <ServiceCard color='bg-[#8945f8]' title='Best Exchange Rates' icon={<BiSearchAlt fontSize={21} className='text-white' />} subtitle='Security is guaranteed. We always maintain privacy and the quality of our products!' />
                <ServiceCard color='bg-[#f84550]' title='Fastest Transactions' icon={<RiHeart2Fill fontSize={21} className='text-white' />} subtitle='Security is guaranteed. We always maintain privacy and the quality of our products!' />

            </div>
        </div>
    )
}

export default Services